export default __webpack_public_path__ + "static/media/MasterCard.5723b413.svg";